export const CERTIFICATES_FEATURE_KEY = 'certificates';
